import React, { useState } from "react";
import '../MobileProductHeader/MobileProductHeader.css';
import { FaSearch, FaFilter } from "react-icons/fa";
import MobileProductFilterPopup from "./MobileProductFilterPopup/MobileProductFilterPopup";

const MobileProductHeader = ({
  search,
  setSearch,
  columnSearch,
  setColumnSearch,
  onRefresh,
}) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [showFilterPopup, setShowFilterPopup] = useState(false);

  const handleRefresh = () => {
    setSearch("");
    setColumnSearch({
      status: "active",
      customerName: "",
      mobile: "",
      coins: "",
      createdBy: "",
      companyName: "",
      lastLoginStartDate: null,
      lastLoginEndDate: null,
      lastTransactionStartDate: null,
      lastTransactionEndDate: null,
      lastLogin: "",
      lastTransaction: "",
      reference: "",
      address: "",
      mapLocation: "",
    });
    if (onRefresh) onRefresh();
  };

  return (
    <>
      <div
        className={`mobile-product-header-wrapper ${
          showFilterPopup ? "blur-background" : ""
        }`}
      >
        <div className="mobile-product-header">
          <div className="mobile-search-product-container">
            <FaSearch className="mobile-search-product-icon" />
            <input
              type="text"
              placeholder="Search here..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="mobile-search-product-input"
            />
          </div>

          <FaFilter
            className="mobile-filter-product-icon"
            onClick={() => setShowFilterPopup(true)}
          />
        </div>
      </div>
      {showFilterPopup && (
        <MobileProductFilterPopup
          onClose={() => setShowFilterPopup(false)}
          columnSearch={columnSearch}
          setColumnSearch={setColumnSearch}
          handleRefresh={handleRefresh}
          onAdd={() => setShowOverlay(true)}
        />
      )}
    </>
  );
};

export default MobileProductHeader;
